import { jsx as _jsx } from "react/jsx-runtime";
import { useSport } from '../context/SportContext';
import CFBGameAnalysis from '../pages/CFBGameAnalysis';
import MLBGameAnalysis from '../pages/MLBGameAnalysis';
import NFLGameAnalysis from '../pages/NFLGameAnalysis';
import GameAnalysis from '../pages/GameAnalysis'; // Fallback to original
const GameAnalysisRouter = () => {
    const { currentSport } = useSport();
    console.log('🎯 GameAnalysisRouter: Routing to sport:', currentSport.id);
    switch (currentSport.id) {
        case 'cfb':
            return _jsx(CFBGameAnalysis, {});
        case 'mlb':
            return _jsx(MLBGameAnalysis, {});
        case 'nfl':
            return _jsx(NFLGameAnalysis, {});
        default:
            // Fallback to original GameAnalysis for any other sports
            console.warn('⚠️  GameAnalysisRouter: Unknown sport, falling back to original GameAnalysis:', currentSport.id);
            return _jsx(GameAnalysis, {});
    }
};
export default GameAnalysisRouter;
